<template>
  <div class="padded">

    <el-col align="left">
      <edit-pane v-if="!hidePanel" ref="ep" prefix="Payment: ":title="form.summary"
      :adding="true"
      :is-edit="editMode"
      @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onAdd" />


      <el-form  :model="form" :inline="true" label-position="top">
        <el-row :gutter="8">
          <el-col :span="24">

            <date-input :label="dueDate" v-model="form.date" placeholder="Paid Date" :disabled="disabled" />
            <text-input v-model="form.ref" label="Reference No." placeholder="Paid Ref" :disabled="disabled" />
            <currency-input v-model="form.amount" :disabled="disabled" />

            <el-form-item label="Taxable">
              <check-box v-model="form.taxable" :disabled="disabled"></check-box>
            </el-form-item>

            <el-form-item v-if="showTax()"  :label="taxLabel">
              <b>{{this.formatNumber(this.tax, 2)}}</b>
            </el-form-item>

            <el-form-item v-if="showTax()"  label="TOTAL">
              <b>{{this.formatNumber(this.totals, 2)}}</b>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>

    </el-col>
  </div>

</template>


<script>


import moment from 'moment'


import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {

  mixins: [DateMixins, NumberMixins, PostMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'tenancy-payments-table'
    },

    adding: {
      type: Boolean,
      default: true
    },

    hidePanel: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    resetData () {
      this.form.organisation_id = null
      this.form.date = null
      this.form.ref = null
      this.form.taxable = this.showTax()
      this.form.amount = 0
      this.form.tax = 0
      this.form.total = 0
    },


    success (response) {
      this.resetData()
      this.$events.emit(this.tableRef + '-refresh-table')
    },


    onCancel () {
      this.disabled = true
    },


    onEdit () {
      this.disabled = false
    },


    onAdd () {
      this.disabled = false

      if (!this.form.amount && this.rowData.landType === 'Rental') {
        this.form.amount = this.rowData.landValue
      }
    },


    onSave () {
      if (!this.form.site_id && this.localSiteId) {
        this.form.site_id = this.localSiteId
      }

      this.form.date = this.formatDateSql(this.form.date)

      this.saveForm(this, '/land/rental', (this.adding ? null : this.form.id), this.form, 'Land Rental Payment', this.success)
      this.disabled = true
      //      this.resetData()

    },


    onClose () {
      this.resetData()
      this.disabled = true
    }

  },



  computed: {

    tax () {
      this.form.tax = this.taxDue(this.form.amount, this.form.taxable)
      return this.form.tax
    },


    totals () {
      this.form.total = this.totalDue(this.form.amount, this.form.tax, this.form.taxable)
      return this.form.total
    }

  },



  data () {

    return {
      currency: settings.currency,
      // Open ready-to-edit. EditPane mounts in edit mode whenever it is
      // `adding` (or `isEdit`) and not view-only, but it renders Cancel/Save
      // directly and never fires @add on mount — so onAdd (which flips this
      // flag) is skipped and the date/text/currency atoms would stay stuck on
      // their read-only display. Mirror EditPane's open-state here so the
      // fields render from the start; viewers stay read-only. (XOL-233)
      disabled: this.isViewOnly() ? true : !(this.adding || this.editMode),
      dueDate: this.rowData.landStarted && this.rowData.landType === 'Rental'
      ? 'Due: ' + moment(this.rowData.landStarted).format('Do') + ' of the month'
      : 'Date Paid',
      amountLabel: (this.rowData.landPaymentFrequency ? this.rowData.landPaymentFrequency + ' ' : '') +
      (this.rowData.landType ? this.rowData.landType + ' ' : '') +
      'Amount: ' + this.formatNumber(this.rowData.landValue, 0),
      taxLabel: settings.taxName,
      format: settings.selectDateFormat,
      form: this.getTableStruct('tenancy_payments')
    }

  },



  mounted () {
    if (this.adding) {
      delete this.form.id
    }

    this.form.site_id = (this.adding ? this.localSiteId : this.form.site_id)
    this.localSiteId = (this.siteId != null ? this.siteId : this.form.site_id)

    if (this.form.site_id && !this.localSiteId) {
      this.localSiteId = this.form.site_id
    }

//    console.log('LicenseePayment- form.site_id', this.form.site_id, 'localSiteId', this.localSiteId, 'siteId', this.siteId, 'rowData', this.rowData)
  }

}

</script>
